export const MAIN_CATEGORIES = [
  {
    name: 'Popular',
    order: 1,
    subcategories: ['Economy', 'Compact', 'Mini',
      'Económico', 'Compacto',
      'Econômico']
  },
  {
    name: 'Family',
    order: 2,
    subcategories: ['MediumSUV', 'StandardSUV', 'SmallSUV', 'Fullsize', 'Standard', 'Intermedio',
      'Grande', 'SUV Estándar', 'SUV Medium', 'SUV Pequeña', 'Estandard', 'Intermediário',
      'SUV Médio', 'SUV Padrão', 'SUV Pequena', 'Midsize', 'Intermediate']
  },
  {
    name: 'Premium',
    order: 3,
    subcategories: ['Premium', 'Luxury', 'Sport', 'Convertible',
      'Intermedio Elite', 'Lujoso', 'Deportivo', 'Esporte',
      'Luxo', 'Conversível']
  },
  {
    name: 'Group',
    order: 4,
    subcategories: ['LargeSUV', 'ExtraLargeSUV', 'LargeVan', 'MiniVAN',
      'Minivan', 'SUV Grande', 'Van Grande', 'Grande', 'VAN Mediana', 'SUV extra grande',
      'VAN Média']
  }
];
